CatalogEnableController.$inject= ['CatalogService'];
export default function CatalogEnableController(CatalogService) {
    var ctrl = this;

    ctrl.$onInit = function() {
        //ctrl.mode = (ctrl.mode) ? ctrl.mode : 'full';
        //ctrl.schema = (ctrl.schema) ? ctrl.schema : 'bib';
        //ctrl.record = {};
    };

    ctrl.$onChanges = function(changes) {
        if (changes) {
            ctrl.id = changes.id.currentValue;
            ctrl.load();
        }
    };

    ctrl.isSuccess = false;
    ctrl.isProcess = false;
    ctrl.isError = false;

    ctrl.load = function() {
        ctrl.isProcess = true;
        CatalogService.get({id: ctrl.id}).$promise.then(function(response) {
            if (response.success) {
                ctrl.enable = response.data[0].enable;
                //ctrl.record_id = response.data[0].id;
                ctrl.isSuccess = true;
            } else {
                ctrl.isError = true;
            }
            ctrl.isProcess = false;
        }, function(error) {
            console.log(error);
            ctrl.isError = error;
            ctrl.isProcess = false;
        });
    };

    ctrl.update = function() {
        ctrl.isProcess = true;
        //CatalogService.update({id: ctrl.record_id}, {enable: ctrl.enable}).$promise.then(function(response) {
        CatalogService.update({id: ctrl.id}, {enable: ctrl.enable}).$promise.then(function(response) {
            if (response.success) {
                ctrl.isSuccess = true;
            } else {
                ctrl.isError = true;
            }
            ctrl.isProcess = false;
        }, function(error) {
            console.log(error);
            ctrl.isError = error;
            ctrl.isProcess = false;
        });
    }
}
